import CurrentGiftsTable from './CurrentGiftsTable';
export default CurrentGiftsTable;
